import { useState } from "react"

export const Searchbar = ({ getWeather }) => {

    const [city, setCity] = useState("")

    const handleSubmit = (e) => {
        e.preventDefault()
        if (city.trim()) {
            getWeather(city)
            setCity("")
        }
    }

    const handleCity = (e) => {
        setCity(e.target.value)
    }

    return (
        <form className="flex"
            onSubmit={handleSubmit}>
            <input type="text"
                placeholder="City Name"
                value={city}
                onChange={handleCity}
                className="p-3 sm:p-4 kdrop-blur-md border border-white/30 outline-none rounded-l-2xl flex-1
            min-w-0 text-white placeholder:text-white/40 focus:bg-white/20 focus:border-white/50 
               transition-all duration-300"/>
            <button type="submit"
                className="p-3 sm:p-4 bg-white text-indigo-600 font-bold rounded-r-2xl 
            hover:bg-opacity-90 transition-all active:scale-95 shrink-0"
            >Search </button>
        </form>
    )
}   